import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { HeroDashboard } from './HeroDashboard';
import { Marquee } from './Marquee';

export function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative isolate overflow-hidden border-b border-hairline">
      {/* Ambient layers — glow first, grid above it, content on top */}
      <div className="glow-hero absolute inset-0 -z-10" aria-hidden />
      <div className="bg-grid absolute inset-0 -z-10" aria-hidden />

      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 pb-12 pt-14 sm:px-6 sm:pb-14 sm:pt-16 lg:grid-cols-2 lg:gap-10 lg:px-8 lg:pt-20">
        <div className="text-center lg:text-left">
          <Badge variant="outline" className="mb-6">
            <Sparkles className="size-3" />
            Finance-grade visibility for AI spend
          </Badge>

          <h1 className="text-balance text-4xl font-semibold leading-[1.06] tracking-tight sm:text-5xl xl:text-6xl">
            Know exactly what your AI{' '}
            <span className="text-glow">costs</span> — to the cent.
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-balance text-base text-muted-foreground sm:text-lg lg:mx-0">
            One dashboard for OpenAI, Anthropic, Google, Cohere, Mistral, and
            self-hosted models. Real-time tracking, budgets, forecasts, and
            anomaly detection — without a proxy in your request path.
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row lg:justify-start">
            <Button size="xl" onClick={() => navigate('/signup')}>
              Start free
              <ArrowRight />
            </Button>
            <Button
              size="xl"
              variant="outline"
              onClick={() => navigate('/demo')}
            >
              View live demo
            </Button>
          </div>

          <p className="mt-6 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs text-muted-foreground lg:justify-start">
            <span>No credit card</span>
            <span aria-hidden>·</span>
            <span>One-line install</span>
            <span aria-hidden>·</span>
            <span>Open source</span>
          </p>
        </div>

        <HeroDashboard />
      </div>

      {/* Provider marquee — part of the first screen, not a scroll reward */}
      <Marquee />
    </section>
  );
}
